/* Tangle Joy 2026 — theme scripts (no dependencies) */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  // Move drawers (mobile menu) to <body>: inside the sticky header, its transform would
  // confine position:fixed panels to the header's height.
  $$('.section-header .drawer').forEach(function (d) { document.body.appendChild(d); });

  // Drawers (mobile menu, filters)
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-open'));
      if (target) {
        e.preventDefault();
        target.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        var focusable = target.querySelector('input, button, a');
        if (focusable) focusable.focus();
      }
      return;
    }
    var closer = e.target.closest('[data-close]');
    if (closer) {
      var panel = closer.closest('.is-open');
      if (panel) {
        e.preventDefault();
        panel.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
    var toggler = e.target.closest('[data-toggle]');
    if (toggler) {
      var el = document.getElementById(toggler.getAttribute('data-toggle'));
      if (el) {
        el.classList.toggle('is-open');
        var input = el.querySelector('input');
        if (el.classList.contains('is-open') && input) input.focus();
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open, .facets.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    document.body.style.overflow = '';
  });

  // Sticky header (sections/header.liquid → "Header when scrolling"):
  // hides on scroll down, returns on scroll up or when the mouse reaches the top of the page.
  // --header-h = full header height, --header-offset = visible height (used by sticky filters / product info)
  var headerWrap = document.querySelector('.section-header');
  var headerEl = headerWrap && headerWrap.querySelector('[data-sticky]');
  var stickyMode = headerEl ? headerEl.getAttribute('data-sticky') : 'always';
  var rootStyle = document.documentElement.style;
  function headerHeight() { return headerWrap ? headerWrap.offsetHeight : 0; }
  // Where the header starts in the page (height of everything above it, e.g. the announcement bar).
  // offsetTop can't be used: for a sticky element it follows the scroll position.
  function headerStart() { var y = 0, el = headerWrap && headerWrap.previousElementSibling; while (el) { y += el.offsetHeight; el = el.previousElementSibling; } return y; }
  function setHeaderVars() {
    var hidden = headerWrap && headerWrap.classList.contains('is-hidden');
    var h = headerHeight();
    rootStyle.setProperty('--header-h', h + 'px');
    rootStyle.setProperty('--header-offset', (stickyMode === 'none' || hidden ? 0 : h) + 'px');
  }
  function showHeader() { if (headerWrap && headerWrap.classList.contains('is-hidden')) { headerWrap.classList.remove('is-hidden'); setHeaderVars(); } }
  function hideHeader() {
    if (!headerWrap || headerWrap.classList.contains('is-hidden')) return;
    if (headerWrap.matches(':hover') || headerWrap.querySelector(':focus') || document.querySelector('.drawer.is-open, .search-bar.is-open')) return;
    headerWrap.classList.add('is-hidden'); setHeaderVars();
  }
  if (headerWrap) {
    if (stickyMode === 'none') headerWrap.classList.add('is-static');
    setHeaderVars();
    window.addEventListener('resize', setHeaderVars);
    if ('ResizeObserver' in window) new ResizeObserver(setHeaderVars).observe(headerWrap);
    if (stickyMode === 'hide_on_scroll' && !(window.Shopify && window.Shopify.designMode)) {
      var lastY = window.scrollY, ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var y = window.scrollY, delta = y - lastY;
          if (y <= headerStart() + headerHeight()) showHeader();
          else if (delta > 6) hideHeader();
          else if (delta < -6) showHeader();
          if (Math.abs(delta) > 6) lastY = y;
          ticking = false;
        });
      }, { passive: true });
      // Mouse at the top edge brings the header back; leaving it hides it again
      document.addEventListener('mousemove', function (e) { if (e.clientY < 70) showHeader(); });
      headerWrap.addEventListener('mouseleave', function () {
        setTimeout(function () { if (window.scrollY > headerStart() + headerHeight() && !headerWrap.matches(':hover')) hideHeader(); }, 800);
      });
    }
  }

  // Hero slideshow (sections/hero-slideshow.liquid): autoplay, arrows, dots, swipe
  $$('[data-slideshow]').forEach(function (root) {
    var track = $('.slideshow__track', root);
    var slides = $$('.slideshow__slide', root);
    var dots = $$('[data-slide-to]', root);
    if (!track || slides.length < 2) return;
    var current = 0;
    var timer = null;
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduced && !(window.Shopify && window.Shopify.designMode);

    function go(i) {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
    }
    function sync() {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      current = Math.max(0, Math.min(slides.length - 1, i));
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === current); d.setAttribute('aria-selected', n === current); });
    }
    function start() { if (autoplay && !timer) timer = setInterval(function () { go(current + 1); }, speed); }
    function stop() { clearInterval(timer); timer = null; }

    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    dots.forEach(function (d) { d.addEventListener('click', function () { stop(); go(parseInt(d.getAttribute('data-slide-to'), 10)); start(); }); });
    var prev = $('[data-slide-prev]', root), next = $('[data-slide-next]', root);
    if (prev) prev.addEventListener('click', function () { stop(); go(current - 1); start(); });
    if (next) next.addEventListener('click', function () { stop(); go(current + 1); start(); });
    if (root.getAttribute('data-pause-hover') === 'true') {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
    }
    root.addEventListener('focusin', stop);
    root.addEventListener('touchstart', stop, { passive: true });
    root.addEventListener('touchend', function () { setTimeout(start, 4000); }, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    window.addEventListener('resize', function () { track.scrollLeft = slides[current].offsetLeft; });
    // Theme editor: jump to the slide being edited
    document.addEventListener('shopify:block:select', function (e) {
      var i = slides.indexOf(e.target);
      if (i > -1) { stop(); go(i); }
    });
    start();
  });

  // Dropdown menus: open to the right of the menu item; if that would cross the right edge of the
  // window, open to the left (right edges aligned), and if it still doesn't fit, slide it fully into view
  $$('.nav__item').forEach(function (item) {
    var dd = item.querySelector(':scope > .nav__dropdown');
    if (!dd) return;
    function place() {
      dd.style.left = ''; dd.style.right = '';
      var vw = document.documentElement.clientWidth, margin = 16;
      var r = dd.getBoundingClientRect();
      if (r.right <= vw - margin) return;
      dd.style.left = 'auto'; dd.style.right = '0';
      r = dd.getBoundingClientRect();
      if (r.left >= margin) return;
      // Too wide for either side (e.g. Shop): line it up with the left edge of the page content
      var start = margin, page = item.closest('.page-width');
      if (page) start = Math.max(margin, page.getBoundingClientRect().left + parseFloat(getComputedStyle(page).paddingLeft));
      start = Math.max(margin, Math.min(start, vw - margin - r.width));
      dd.style.right = 'auto'; dd.style.left = (start - item.getBoundingClientRect().left) + 'px';
    }
    function fit() {
      // The dropdown may still be display:none when this runs, so show it while measuring
      dd.style.visibility = 'hidden';
      dd.style.display = dd.classList.contains('nav__dropdown--mega') ? 'grid' : 'block';
      place();
      dd.style.display = ''; dd.style.visibility = '';
    }
    item.addEventListener('mouseenter', fit);
    item.addEventListener('focusin', fit);
    window.addEventListener('resize', function () { if (item.matches(':hover, :focus-within')) fit(); });
  });

  // Announcement rotator
  $$('[data-rotator]').forEach(function (root) {
    var slides = $$('.announcement__slide', root);
    if (slides.length < 2) return;
    var i = 0;
    var speed = parseInt(root.getAttribute('data-rotator'), 10) || 5000;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, speed);
  });

  // Tabs
  $$('[data-tabs]').forEach(function (root) {
    var tabs = $$('[role="tab"]', root);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var selected = t === tab;
          t.setAttribute('aria-selected', selected);
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
      });
    });
  });

  // Collection: sort + filter auto-submit
  $$('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
  $$('form[data-facets]').forEach(function (form) {
    var mq = window.matchMedia('(min-width: 990px)');
    form.addEventListener('change', function (e) {
      if (!mq.matches) return; // mobile uses the Apply button
      if (e.target.type === 'number') return;
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
    form.addEventListener('submit', function () {
      $$('input', form).forEach(function (input) {
        if ((input.type === 'number' || input.type === 'text') && input.value === '') input.disabled = true;
      });
    });
  });

  // Product gallery
  $$('[data-gallery]').forEach(function (root) {
    var track = $('.gallery__slides', root);
    var slides = $$('.gallery__slide', root);
    var thumbs = $$('.gallery__thumb', root.parentNode);
    var counter = $('.gallery__counter', root);
    if (!track || slides.length === 0) return;
    function go(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }
    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    track.addEventListener('scroll', function () {
      var i = current();
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }, { passive: true });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    var prev = $('.gallery__nav--prev', root);
    var next = $('.gallery__nav--next', root);
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    root.goToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) { go(i); break; }
      }
    };
  });

  // Product gallery zoom: hover magnifier + full-screen viewer (settings in the Product information section)
  $$('.product__gallery').forEach(function (gallery) {
    var scale = parseFloat(gallery.getAttribute('data-zoom-scale')) || 2.5;
    var imgs = $$('.gallery__img', gallery);
    var desktop = window.matchMedia('(hover: hover) and (min-width: 990px)');

    function useZoomSource(img) {
      var big = img.getAttribute('data-zoom');
      if (big && img.getAttribute('src') !== big) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = big; }
    }

    if (gallery.classList.contains('gallery--hover-zoom')) {
      imgs.forEach(function (img) {
        var slide = img.closest('.gallery__slide');
        slide.addEventListener('mouseenter', function () { if (!desktop.matches) return; useZoomSource(img); slide.classList.add('is-zooming'); });
        slide.addEventListener('mousemove', function (e) {
          if (!desktop.matches) return;
          var r = slide.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
        slide.addEventListener('mouseleave', function () { slide.classList.remove('is-zooming'); img.style.transformOrigin = ''; });
      });
    }

    var box = $('.lightbox', gallery);
    if (!box || imgs.length === 0) return;
    document.body.appendChild(box); // escape transformed/sticky parents
    box.style.setProperty('--lb-scale', scale);
    var lbImg = $('.lightbox__img', box);
    var counter = $('.lightbox__counter', box);
    var current = 0;
    var sources = imgs.map(function (img) { return { src: img.getAttribute('data-zoom') || img.currentSrc || img.src, alt: img.alt }; });

    function show(i) {
      current = (i + sources.length) % sources.length;
      box.classList.remove('is-zoomed');
      lbImg.style.transformOrigin = '';
      lbImg.src = sources[current].src;
      lbImg.alt = sources[current].alt;
      counter.textContent = (current + 1) + ' / ' + sources.length;
    }
    function open(i) { show(i); box.hidden = false; document.body.style.overflow = 'hidden'; }
    function close() { box.hidden = true; document.body.style.overflow = ''; }

    // Opening: expand buttons, "+N" tile, or clicking a gallery image (no hover zoom on touch screens)
    gallery.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-lightbox-open]');
      if (opener) { e.preventDefault(); open(parseInt(opener.getAttribute('data-lightbox-open'), 10) || 0); return; }
      var img = e.target.closest('.gallery__img');
      if (img) open(imgs.indexOf(img));
    });
    $('[data-lightbox-close]', box).addEventListener('click', close);
    $('[data-lightbox-prev]', box).addEventListener('click', function () { show(current - 1); });
    $('[data-lightbox-next]', box).addEventListener('click', function () { show(current + 1); });
    box.addEventListener('click', function (e) { if (e.target === box || e.target.classList.contains('lightbox__stage')) close(); });
    lbImg.addEventListener('click', function (e) {
      var zoomed = box.classList.toggle('is-zoomed');
      if (zoomed) {
        var r = lbImg.getBoundingClientRect();
        lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      }
    });
    lbImg.addEventListener('mousemove', function (e) {
      if (!box.classList.contains('is-zoomed')) return;
      var r = box.getBoundingClientRect();
      lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
    var touchX = null;
    box.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (touchX === null || box.classList.contains('is-zoomed')) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 50) show(current + (dx < 0 ? 1 : -1));
      touchX = null;
    });
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  });

  // Variant picker
  $$('[data-product-json]').forEach(function (script) {
    var product;
    try { product = JSON.parse(script.textContent); } catch (err) { return; }
    var section = script.closest('[data-product-section]');
    if (!section) return;
    var picker = $('.variant-picker', section);
    var idInput = $('form[action*="/cart/add"] input[name="id"]', section);
    var buttons = $$('[data-add-button]', section);
    var priceEls = $$('[data-price]', section);
    var gallery = $('[data-gallery]', section);
    var money = section.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return money
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/, withCommas);
    }

    function selectedOptions() {
      return $$('fieldset', picker).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      $$('fieldset', picker).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var exists = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return o === test[i]; });
          });
          input.classList.toggle('is-unavailable', !exists);
        });
        var label = $('[data-selected-value]', fs);
        if (label) label.textContent = opts[idx] || '';
      });
      buttons.forEach(function (btn) {
        if (!variant) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); return; }
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
      });
      if (!variant) return;
      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      priceEls.forEach(function (el) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        el.innerHTML = '<div class="price' + (onSale ? ' price--sale' : '') + '"><span class="price__current">' + formatMoney(variant.price) + '</span>' +
          (onSale ? '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>' : '') + '</div>';
      });
      if (variant.featured_media && gallery && gallery.goToMedia) gallery.goToMedia(variant.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    if (picker) picker.addEventListener('change', update);
  });

  // Quantity buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    input.value = Math.max(parseInt(input.min || '0', 10), val + parseInt(btn.getAttribute('data-qty'), 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Sticky add-to-cart on mobile
  $$('[data-sticky-atc]').forEach(function (bar) {
    var anchor = document.getElementById(bar.getAttribute('data-sticky-atc'));
    if (!anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(anchor);
    var btn = $('button', bar);
    if (btn) btn.addEventListener('click', function () {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  // Cart: auto-update quantity
  $$('form[data-cart-form]').forEach(function (form) {
    var timer;
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'updates[]') return;
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 500);
    });
  });

  // Age gate
  var gate = document.getElementById('AgeGate');
  if (gate) {
    var KEY = 'tj_age_ok';
    var ok = false;
    try { ok = window.localStorage.getItem(KEY) === '1'; } catch (err) { ok = document.cookie.indexOf(KEY + '=1') > -1; }
    if (!ok && !/bot|crawl|spider|lighthouse|google/i.test(navigator.userAgent)) {
      gate.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    var enter = document.getElementById('AgeGateEnter');
    if (enter) enter.addEventListener('click', function () {
      try { window.localStorage.setItem(KEY, '1'); } catch (err) { /* ignore */ }
      document.cookie = KEY + '=1; path=/; max-age=' + 60 * 60 * 24 * 30;
      gate.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }
})();
